import {styled} from "@mui/material/styles"

export const Cotton22FacetsWrapper = styled("div")`
    display: flex;
    flex-direction: column;
    max-height: 35vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 0.25rem;
    &::-webkit-scrollbar {
        width: 1rem;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    &::-webkit-scrollbar-track {
        background: #fafafa;
        border-radius: 0rem 0rem 0.25rem 0rem;
    }
    &::-webkit-scrollbar-thumb {
        border: 0.3rem solid ${({theme}) => theme.colours.popover.header.backgroundColour};
        background: #616161;
        border-radius: 1rem;
    }
`

export default Cotton22FacetsWrapper
